import(/* webpackMode: "eager" */ "/opt/build/repo/application/src/app/error.tsx");
